import { render, staticRenderFns } from "./EntryMessageHistory.vue?vue&type=template&id=5d038c46"
import script from "./EntryMessageHistory.vue?vue&type=script&lang=js"
export * from "./EntryMessageHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports